import axios from "../../axios";

const state = {
  list: [],
  libraryDictionaryList: [],
  pagination: {
    current_page: 1,
    per_page: 20,
    total: 0,
  },
};

const actions = {
  async getAll({ commit }, payload) {
    const response = await axios.get("library-dictionary", { params: payload });
    if (response.status === 200) {
      commit("SET_LIST", response.data.data);
    }
    return response;
  },

  async getList({ commit }, payload) {
    const response = await axios.get("library-dictionary/list", {
      params: payload,
    });
    if (response.status === 200) {
      commit("SET_LIST_LIBRARY_DICTIONARY", response.data.data);
    }
    return response;
  },

  async create({ commit }, payload) {
    const response = await axios.post("library-dictionary", payload);
    if (response.status === 200) {
      if (payload.type === response.data.data.type) {
        commit("CREATE_LIBRARY_DICTIONARY", response.data.data);
      }
    }
    return response;
  },

  async update({ commit }, { id, payload }) {
    const response = await axios.put("library-dictionary/" + id, payload);
    if (response.status === 200) {
      if (payload.type === response.data.data.type) {
        commit("UPDATE_LIBRARY_DICTIONARY_SAME_TYPE", response.data.data);
      } else {
        commit("UPDATE_LIBRARY_DICTIONARY_DIFFERENT_TYPE", response.data.data);
      }
    }
    return response;
  },

  async delete({ commit }, id) {
    const response = await axios.delete("library-dictionary/" + id);
    if (response.status === 200) {
      commit("DELETE_LIBRARY_DICTIONARY", id);
    }
    return response;
  },

  /**
   * set current page
   * @param commit
   * @param data
   */
  setCurrentPage({ commit }, data) {
    commit("SET_LIBRARY_DICTIONARY_CURRENT_PAGE", data);
  },

  /**
   * set per page
   * @param commit
   * @param data
   */
  setPerPage({ commit }, data) {
    commit("SET_LIBRARY_DICTIONARY_PER_PAGE", data);
  },
};

const mutations = {
  SET_LIST(state, data) {
    state.list = data.data;
  },

  SET_LIST_LIBRARY_DICTIONARY(state, data) {
    state.libraryDictionaryList = data.data;
    state.pagination = data.pagination;
  },

  CREATE_LIBRARY_DICTIONARY(state, data) {
    console.log("CREATE_LIBRARY_DICTIONARY");
    console.log(data);
    state.libraryDictionaryList.unshift(data);
  },

  UPDATE_LIBRARY_DICTIONARY_SAME_TYPE(state, data) {
    const index = state.libraryDictionaryList.findIndex(
      (u) => u.id === data.id,
    );
    if (index >= 0) {
      state.libraryDictionaryList.splice(index, 1, data);
    }
  },

  UPDATE_LIBRARY_DICTIONARY_DIFFERENT_TYPE(state, data) {
    const index = state.libraryDictionaryList.findIndex(
      (u) => u.id === data.id,
    );
    if (index >= 0) {
      state.libraryDictionaryList.splice(index, 1);
    }
  },

  DELETE_LIBRARY_DICTIONARY(state, itemId) {
    const index = state.libraryDictionaryList.findIndex((u) => u.id === itemId);
    if (index >= 0) {
      state.libraryDictionaryList.splice(index, 1);
    }
  },

  SET_LIBRARY_DICTIONARY_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },

  SET_LIBRARY_DICTIONARY_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
